export default __webpack_public_path__ + "static/media/eliqx-how-it-works-step-2.39734045.jpg";